<template>
	<div class="container-friends">
	<van-nav-bar
		id='van-nav-bar'
		title="团队管理"
		left-text="返回"
		left-arrow
		fixed
		@click-left="onClickLeft"
	/>
	<!-- <div class="tab-box">
		<div class="tabs" type="card" @click="tabClick">
			<div>
				<span>总好友数:{{total}}</span>
			</div>
			<div>
				<span>本周新增:{{countWeek}}</span>
			</div>
		</div>
	</div> -->
	<div class="data-wrapper">
		<van-list
			v-model="loading"
			:immediate-check="true"
			:finished="finished"
			finished-text="没有更多了"
			@load="listLoad"
			>
			<!-- <van-cell v-for="item in list" :key="item" :title="item" /> -->
			<van-cell>
				<FriendItem
					v-for="item in list"
					:key="item.id"
					:avatar='item.wechatUrl'
					:friendName= 'item.wechatName'
					:time= 'item.createTime'
					:amount= 'item.totalAmount'
					:friendId= 'item.friendId'
				/>
			</van-cell>
			
		</van-list>
	</div>
	</div>
</template>
<script>
	import Vue from 'vue'
	import {friendReturn,friendList2} from "../../utils/api";
	import FriendItem from "@/components/FriendItem.vue";
	import { app } from "../../utils/app";
	import { NavBar, Tab, Tabs, List, Cell} from "vant";
	import Vuex from 'vuex'
	Vue.use(NavBar);
	Vue.use(Tab)
	Vue.use(Tabs)
	Vue.use(Vuex)
	Vue.use(List)
	Vue.use(Cell)
	
	// @ is an alias to /src

	export default {
		name: 'ShopData',
		components: {
			FriendItem
		},
		data() {
			return {
				list:[],
				listWeek:'',
				shopToken:'',
				total:'',//总好友数
				type:0 ,// 0全部，1本周
				// userToken:'acfd2b3f71a14992a9bdd358e39b46d5',
				userToken:'',
				count:'',
				countWeek:0,
				offset:0,
				limit:10,
				loading:false,
				finished:false,
				custId:''
			}
		},
		created() {
			let userToken = app.getUserToken();
			let shopToken = app.getShopToken();
			this.custId = app.storage.get('shopInfo').custId
			this.userToken = userToken;
			this.shopToken = shopToken;
		},
		mounted() {
			// this.getFriendList()
			// this.getFriendReturn()
		},
		watch: {
		},
		methods: {
			async getFriendList(){
				this.loading = true
				let params= {
						// custId:this.custId,
						limit:this.limit,
						offset:this.offset,
						usertoken:this.shopToken
					}
				let res= await friendList2(params)
				// this.list= res.data.data.rows
				if (res.data.code == 0) {
					if (res.data.customerFriendsList.length<this.limit) {
						this.finished = true
					}
					this.list = [...this.list,...res.data.customerFriendsList]
					// this.total= res.data.data.total
					this.count= res.data.count
					// this.countWeek= res.data.countWeek || this.countWeek

					this.offset = this.offset + this.limit
					this.loading = false
				}else{
					this.loading = false
				}
				
			},
			async getFriendReturn(){
				let params= {
						token:this.userToken,
						limit:10,
						offset:0
					}
				let res= await friendReturn(params)
				console.log(res)
			},
			onClickLeft(){
				this.$router.back()
			},
			tabClick(e,r){
				console.log(e,r)
				this.type = e
			},
			listLoad(){
				console.log('listLoad')
				//判断是否有更多数据
				// if(this.total>this.offset){//继续请求
					// console.log('还有数据')
					this.getFriendList()
				// }else{//没有更多数据
				// 	console.log('没有数据了')
				// 	this.finished = true
				// }
			}
		}
	}
</script>
<style lang="scss">
.container-friends{
	margin-top: 46px;
	.data-wrapper{
		button{
			width: 12.5rem;
			height: 3.125rem;
			margin: 0.625rem;
		}
	}
	.tabs{
		min-height: 60px;
		display: flex;
		justify-content: space-around;
		align-items: center;
		color: #FFB103;
		font-size: 1rem;
		font-weight: bold;
	}
	
}
	
</style>
